export var TypeTemporality;
(function (TypeTemporality) {
    TypeTemporality["BEFORE"] = "before";
    TypeTemporality["AFTER"] = "after";
    TypeTemporality["BETWEEN"] = "between";
})(TypeTemporality || (TypeTemporality = {}));
